import {Injectable} from '@angular/core';

@Injectable()
export class CustomScrollbarService {

    /**
     * Equality to zero means that the native browser's scrollbar is iOS-like.
     */
    public scrollbarWidth: number;

    /**
     * Can be not zero in case if the browser doesn't support such styles for native scrollbar.
     */
    public hiddenScrollbarWidth: number;

}
